import { withFrameBusProps } from '@jusbrasil-web/shared-frame-bus'
import { withUserSession, WithUserSessionReturn } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { withBoxPaywallFrameBusID } from '../../frame-bus'
import { BoxPageBase } from './base'

export type BoxUniqueFeaturePaywallIframeProps = {
  resourceId: string
}

export const BoxUniqueFeaturePaywallIframe = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const { resourceId } = props
  const id = withBoxPaywallFrameBusID(resourceId)
  return <BoxPageBase {...props} id={id} enableResizeListener />
}

const getServerSideProps: GetServerSideProps<
  BoxUniqueFeaturePaywallIframeProps & ReturnType<typeof withFrameBusProps> & WithUserSessionReturn
> = async (ctx) => {
  const { resourceId: resIdArg } = ctx.query
  const resourceId = Array.isArray(resIdArg) ? resIdArg[0] : resIdArg || ''
  return {
    props: {
      ...withFrameBusProps(),
      ...withUserSession(ctx),
      resourceId,
    },
  }
}

export const BoxUniqueFeaturePaywallIframeExports = { getServerSideProps }
